import { render, staticRenderFns } from "./IMListApproval.vue?vue&type=template&id=2b292962&scoped=true&lang=pug"
import script from "./IMListApproval.vue?vue&type=script&lang=js"
export * from "./IMListApproval.vue?vue&type=script&lang=js"
import style0 from "./IMListApproval.vue?vue&type=style&index=0&id=2b292962&prod&scoped=true&lang=css"
import style1 from "./IMListApproval.vue?vue&type=style&index=1&id=2b292962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b292962",
  null
  
)

export default component.exports